import { useEffect,useState } from "react";
import MypageContainer from "../components/mypage/MyPageContainer";
import MyPageContent from "../components/mypage/MyPageContent";
import axios from 'axios';

import styles from './mypage/Price.module.css'; // CSS Modules 파일 import

const Test = () => {
  useEffect(() => {
    // NICEPAY 스크립트 동적 추가
    const script = document.createElement("script");
    script.src = "https://pay.nicepay.co.kr/v1/js/";
    script.async = true;
    document.body.appendChild(script);

    // serverAuth 함수 정의
    window.serverAuth = function (goodsName,amount) {
      if (!window.AUTHNICE) {
        alert("결제 스크립트가 아직 로드되지 않았습니다.");
        return;
      }
    const orderId = "ORD-" + Date.now() + "-" + Math.floor(Math.random() * 100000);

      window.AUTHNICE.requestPay({
        clientId: "R2_a1f7d37d407e496da79b2efdb3fefe95",
        method: "card",
        orderId: orderId,
        amount: amount,
        goodsName: goodsName,
        returnUrl: `${process.env.REACT_APP_SERVER_URL}/nicepay/original`,
        fnError: function (result) {
          alert('개발자확인용 : ' + result.errorMsg + '')
        }
      });
    };

    // cleanup
    return () => {
      document.body.removeChild(script);
    };
  }, []);

    const [formData, setFormData] = useState({
    cardNo: "",
    expMonth: "",
    expYear: "",
    idNo: "",
    cardPw: "",
    // cardNo: "5181850045162037",
    // expMonth: "02",
    // expYear: "30",
    // idNo: "970308",
    // cardPw: "27",
  });

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://pay.nicepay.co.kr/v1/js/";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // input 값 변경 처리
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 서버로 form 제출
  const handleSubmit = async (e) => {
    e.preventDefault(); // 기본 폼 제출 막기
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/nicepay/regular`,formData);
        if(response.status==200){
            alert('정기결제가 완료되었습니다.');
            window.location.reload();
        }
    } catch (err) {
      console.error("서버 제출 오류:", err);
      alert("서버 제출 실패");
    }
  };


return (
 <div className="mypageContainer">
            <MypageContainer>
                <MyPageContent>
                    {/* <div className={styles.titleBox}>
                        <h1>유지보수 가격 안내</h1>
                        <ul className={styles.titleMenu}>
                            <li><div className={styles.menuItem} onClick={handleButtonClick1}>사이트 유지보수</div></li>
                            <li><div className={styles.menuItem} onClick={handleButtonClick2}>도메인 / 호스팅</div></li>
                            <li><div className={styles.menuItem} onClick={handleButtonClick3}>디자인 상품</div></li>
                        </ul>
                        <p className={styles.produce}>
                            작업범위, 서비스 안내 등 기타 문의사항이 있으면 <span className={styles.red}>채팅 서비스</span>를 이용해주세요.
                        </p>
                    </div> */}
                    <div className={styles.priceContainer}>
                        <div className={styles.categoryArti}>
                            <h2>사이트 유지보수</h2>
                            <ul className={styles.itemList}>
                                <li>
                                    <div className={styles.item}>
                                        <h3>베이직</h3>
                                        <div className={styles.txt}>
                                            간단한 프로젝트로 일하는 신생 스타트업 및 개발 팀에 추천합니다. 
                                        </div>
                                        <div className={styles.price}>500,000</div>
                                        <button type="button" className={styles.applyBtn} onClick={() => window.serverAuth('베이직상품',500000)}>결제하기</button>
                                        <ul className={styles.subList}>
                                            <li>텍스트 수정 무제한 </li>
                                            <li>이미지 제작 월 2건</li>
                                            <li>팝업제작 분기별 1건</li>
                                            <li>배너 제작 </li>
                                            <li>이벤트 페이지 제작</li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.item}>
                                        <h3>스탠다드</h3>
                                        <div className={styles.txt}>
                                            소규모 프로젝트로 일하는 신생 스타트업 및 개발 팀에 추천합니다. 
                                        </div>
                                        <div className={styles.price}>1,000,000</div>
                                        <button type="button" className={styles.applyBtn} onClick={() => window.serverAuth('레어상품',1000000)}>결제하기</button>
                                        <ul className={styles.subList}>
                                            <li>텍스트 수정 무제한 </li>
                                            <li>이미지 제작 월 2건</li>
                                            <li>팝업제작 분기별 1건</li>
                                            <li>배너 제작 </li>
                                            <li>이벤트 페이지 제작</li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <div className={styles.item}>
                                        <h3>프리미엄</h3>
                                        <div className={styles.txt}>
                                            어느정도 규모있는 프로젝트로 일하는 신생 스타트업 및 개발 팀에 추천합니다. 
                                        </div>
                                        <div className={styles.price}>1,500,000</div>
                                        <button type="button" className={styles.applyBtn} onClick={() => window.serverAuth('에픽상품',1500000)}>결제하기</button>
                                        <ul className={styles.subList}>
                                            <li>텍스트 수정 무제한 </li>
                                            <li>이미지 제작 월 2건</li>
                                            <li>팝업제작 분기별 1건</li>
                                            <li>배너 제작 </li>
                                            <li>이벤트 페이지 제작</li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <form onSubmit={handleSubmit} className={styles.card_form}>
                                        <div className={styles.item}>
                                            <div className={styles.txt}>
                                              <label>카드번호</label>
                                              <input type="text" required className={styles.ipt} name="cardNo" value={formData.cardNo} onChange={handleChange} />
                                              <label>만료월 (MM)</label>
                                              <input type="text" required className={styles.ipt} name="expMonth" value={formData.expMonth} onChange={handleChange} />
                                              <label>만료년도 (YY)</label>
                                              <input type="text" required className={styles.ipt} name="expYear" value={formData.expYear} onChange={handleChange} />
                                              <label>생년월일 / 사업자번호</label>
                                              <input type="text" required className={styles.ipt} name="idNo" value={formData.idNo} onChange={handleChange} />
                                              <label>카드비밀번호 앞2자리</label>
                                              <input type="text" required className={styles.ipt} name="cardPw" value={formData.cardPw} onChange={handleChange} /></div>
                                              <div className={styles.price}>500,000</div>
                                              <button type="submit" className={styles.applyBtn}>정기결제</button>
                                        </div>
                                    </form>
                                </li>
                            </ul>
                        </div>
                    </div>
                </MyPageContent>
            </MypageContainer>
        </div>
  );
};

export default Test;
